module.exports = __webpack_public_path__ + "./img/LogoWeb.f9d9d898921895ac936bb3778722da5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/LogoWeb.png
// module id = ./src/assets/img/brand/LogoWeb.png
// module chunks = 14